"use client";

import React from "react";
import { cn } from "utils/utils";
import { UserHoverCard } from "modules/common/components/navigation/UserHoverCard";
import { TradeItem } from "modules/tradeLists/model/tradeList";
import { CityItemStore } from "modules/city/model/cityCards";
import { StoreDropdownButton } from "modules/city/components/client/StoreDropdownButton";
import { useCardGridItemContext } from "./CardGridItemContext";

interface CardGridItemUserInfoProps {
  stores?: CityItemStore[];
  /** Typed TradeItem for StoreDropdownButton (avoids cast from context) */
  storeItem?: TradeItem;
  usernameMaxLength?: number;
  className?: string;
  /** Right-side slot content — compose with QuantityPrice, PostedTime, etc. */
  children?: React.ReactNode;
}

export function CardGridItemUserInfo({
  stores,
  storeItem,
  usernameMaxLength = 15,
  className,
  children,
}: CardGridItemUserInfoProps) {
  const { item } = useCardGridItemContext();

  if (!item.user) return null;

  return (
    <div className={cn("flex items-center justify-between", className)}>
      <div className="flex min-w-0 items-center gap-2">
        <UserHoverCard
          userId={item.user.id}
          size="xs"
          username={item.user.username}
          avatar={item.user.preferredAvatar}
          maxUsernameLength={usernameMaxLength - 3}
          usernameClassName="text-primary text-sm font-medium"
          activityStatus={item.activityStatus}
        />
        {stores && stores.length > 0 && storeItem && (
          <StoreDropdownButton stores={stores} size="xs" item={storeItem} />
        )}
      </div>

      {children}
    </div>
  );
}
